import './ApproveButton.css';

interface ApproveButtonProps {
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  label?: string;
  quickApprove?: boolean;
  onQuickApprove?: () => void;
}

export default function ApproveButton({
  onClick,
  disabled = false,
  loading = false,
  label = 'Approve',
  quickApprove = false,
  onQuickApprove,
}: ApproveButtonProps) {
  return (
    <div className="approve-bar">
      {quickApprove && onQuickApprove && (
        <button
          className="quick-approve-btn"
          onClick={onQuickApprove}
          disabled={disabled || loading}
        >
          Quick Approve
        </button>
      )}
      <button
        className="approve-btn"
        onClick={onClick}
        disabled={disabled || loading}
        title={`${label} (\u2318\u21A9)`}
      >
        {loading ? 'Saving...' : label}
      </button>
    </div>
  );
}
